import axios from "axios";
import { GET_FOTOR_BASE_URL } from "~/utils/common";

// 创建axios实例
const service = axios.create({
  baseURL: GET_FOTOR_BASE_URL()
});

// 获取用户信息
export function getLoginInfo(token: string) {
  return service({
    url: '/User/GetLoginState',
    headers: {
      Authorization: 'bearer ' + token
    },
    method: "get"
  });
}

// 检测兑换码
export function checkCode(code: string, planIdListStr: string, token: string) {
  return service({
    url: '/pay/service/en/payment/check/code',
    headers: {
      Authorization: 'bearer ' + token
    },
    method: "get",
    params: {
      code,
      planIdListStr
    }
  });
}


// 兑换码 
export function postCode(code: string, token: string) {
  let formData = new FormData()
  formData.append('code', code)

  return service({
    url: '/pay/service/en/payment/exchange/subscribe',
    headers: {
      Authorization: 'bearer ' + token,
      'Content-Type': 'multipart/form-data'
      // 'Content-type': 'application/x-www-form-urlencoded'
    },
    method: "post",
    data: formData
  });
}